import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';

@Component({
  selector: 'month-dropdown',
  templateUrl: './month-dropdown.component.html',
  styleUrls: ['./month-dropdown.component.scss'],
  standalone: false,
})
export class MonthDropdownComponent {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  @Input() month: number;
  @Output() monthChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  /** A parent fieldset disables the native control; mat-select does not inherit that. */
  get disabledByFieldset(): boolean {
    const fieldset = this.elementRef.nativeElement.closest('fieldset');

    return fieldset instanceof HTMLFieldSetElement && fieldset.disabled;
  }

  emitValue() {
    this.monthChange.emit(this.month);
  }
}
